<template>
	<div class="detail-form">
		<div class="row" v-show="!isLoadingOfferStatus">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="name">Nome do Status da Oferta: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.name ? 'alert' : '']"
					id="name"
					type="text"
					placeholder="Nome do Status da Oferta"
					v-model="status.name"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.name">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="PT-BR"
					value="PT-BR"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingOfferStatus">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="secondName">Nome do Status da Oferta: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.secondName ? 'alert' : '']"
					id="secondName"
					type="text"
					placeholder="Nome do Status da Oferta"
					v-model="status.secondName"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.secondName">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="status">Idioma:</label>
				<input
					class="detail-form__field--input disabled"
					id="name"
					type="text"
					placeholder="EN-US"
					value="EN-US"
				/>
			</div>
		</div>
		<div class="row" v-show="!isLoadingOfferStatus">
			<div class="detail-form__field w-100">
				<label class="detail-form__field--label" for="color">Cor: *</label>
				<input
					class="detail-form__field--input color"
					:class="[requiredFields.color ? 'alert' : '']"
					id="color"
					type="text"
					placeholder="Cor"
					v-model="status.color"
				/>
				<div class="color-indicator" :style="`background: ${status.color}`"></div>
				<small class="detail-form__field--input--required" v-if="requiredFields.color">
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div
			class="detail-form__actions"
			:class="newStatus ? 'new-status' : ''"
			v-show="!isLoadingOfferStatus"
		>
			<button
				class="detail-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newStatus"
			>
				Excluir Status da Oferta
			</button>
			<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingOfferStatus">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Status da Oferta'"
			:subtitle="'Tem certeza que deseja excluir este status?'"
			:loader="isLoadingOfferStatus"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_OFFER_STATUS_BY_ID,
	CREATE_STATUS,
	UPDATE_STATUS,
	DELETE_STATUS,
} from '@/store/modules/offerStatusManagement/actions';
import { mask } from 'vue-the-mask';
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';

export default {
	name: 'OfferStatusForm',
	directives: { mask },
	components: { GenericMultiselect, SpinnerIcon, DeleteModal },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		status: {
			name: '',
			secondName: '',
			color: '',
		},
		requiredFields: {
			name: false,
			secondName: false,
			color: false,
		},
		newStatus: false,
		isEditing: false,
		showDeleteModal: false,
	}),
	created() {},
	mounted() {
		if (this.$route.query.id) {
			this.getStatus({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedStatus = res.data;

				selectedStatus.forEach((item) => {
					if (item.language == 'pt-br') this.status.name = item.name;
					if (item.language == 'en-us') this.status.secondName = item.name;
					this.status.color = item.color;
				});
			});
		} else {
			this.newStatus = true;
		}
	},
	methods: {
		...mapActions('offerStatusManagement', {
			getStatus: GET_OFFER_STATUS_BY_ID,
			createNewStatus: CREATE_STATUS,
			updateStatus: UPDATE_STATUS,
			deleteStatus: DELETE_STATUS,
		}),
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		confirmDelete() {
			this.deleteStatus({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/offerStatus' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		createStatus() {
			const body = {
				itens: [],
				color: this.status.color,
			};

			body.itens.push(
				{ name: this.status.name, language: 'pt-br' },
				{ name: this.status.secondName, language: 'en-us' },
			);

			this.createNewStatus({ vm: this, body: body }).then((res) => {
				if (res.status == 201) {
					this.$router.push({ path: '/dashboard/offerStatus' });
				}
			});
		},
		confirmUpdate() {
			const body = {
				itens: [],
				color: this.status.color,
			};

			body.itens.push(
				{ name: this.status.name, language: 'pt-br' },
				{ name: this.status.secondName, language: 'en-us' },
			);

			this.updateStatus({ vm: this, id: this.$route.query.id, body: body }).then((res) => {
				if (res.status == 200) {
					this.isEditing = false;
				}
			});
		},
		validateFields() {
			this.requiredFields = {
				name: true,
				secondName: true,
				color: true,
			};

			if (this.status.name) this.requiredFields.name = false;
			if (this.status.secondName) this.requiredFields.secondName = false;
			if (this.status.color) this.requiredFields.color = false;

			if (!this.status.name || !this.status.secondName || !this.status.color) {
				return;
			}

			if (!this.newStatus) {
				this.confirmUpdate();
			} else {
				this.createStatus();
			}
		},
	},
	computed: {
		...mapGetters('offerStatusManagement', ['isLoadingOfferStatus']),
	},
	watch: {
		'status.color'(newValue) {
			if (newValue.length >= 1 && !newValue.includes('#')) {
				this.status.color = `#${this.status.color}`;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferStatusForm.scss';
</style>
